import { render, staticRenderFns } from "./ViewDetailsModal.vue?vue&type=template&id=86c24ea6&scoped=true&"
import script from "./ViewDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ViewDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetailsModal.vue?vue&type=style&index=0&id=86c24ea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c24ea6",
  null
  
)

export default component.exports